module.exports = __webpack_public_path__ + "img/rub.c2cd3e3e.svg";